import purple from '@material-ui/core/colors/purple';
import grey from '@material-ui/core/colors/grey';
import red from '@material-ui/core/colors/red';

export const primary = {
  main: purple[500],
}
export const secondary = {
  main: grey[800],
}

export const danger = {
  main: red[800],
}
